module.exports = "/dist/images/es.fdbdbac6.png";